import { useSelector } from 'react-redux';
import { selectIsUserPrime } from '@paradigm/store/src/auth/selectors';

const useIsViewerPrime = () => {
  const isPrimeUser = useSelector(selectIsUserPrime);
  return isPrimeUser;
};

export default useIsViewerPrime;
